import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    query: {},
    address: [],
    activeAddress: '',
    profile: {},
    shippingtype: '',
    orderid: '',
    redirect: '',
    input: '',
    registerData: '',
    registerType: '',
    show: null,
    viewAfterAgreement: '',
    consentData: '',
    statuslogin: false,
    taxloading: false,
    isNewUser: false,
    statusregister: false,
    userid: ''
  },
  mutations: {
  },
  actions: {
    messengerClose() {
      MessengerExtensions.requestCloseBrowser(
        function success() { },
        function error() {
          close();
          window.close();
          window.location.assign(
            "https://www.messenger.com/closeWindow/?image_url=https://www.zwiz.ai/web/public/img/zwiz_logo_white.png&display_text=Closing window..."
          );
        }
      );
    }
  },
  modules: {
  }
})
